import Base from "../base";

export default class PeriodoServices extends Base {
  static endpointUrl = "encuestas/periodos/";
}
